export const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined);

export const required = message => value => (value ? undefined : message);

export const email = message => value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? message : undefined;

export const phoneNumber = message => value =>
    value && !/^([0-9]{3,14})$/i.test(value) ? message : undefined

export const limit = (message, limit) => value => {
    if (!value) return undefined;
    const count = [...value.toString()].length;
    return count > limit
        ? message.toString().replace('{limit}', limit).replace('{count}', count)
        : undefined;
};

export const currency = message => value =>
    value && !/^\d+(\.\d{1,2})?$/i.test(value) ? message : undefined;

export const minNumber = (message, number) => value =>
    value && parseFloat(value) < number ?
        message.toString().replace('{number}', number) : undefined;

export const maxNumber = (message, number) => value =>
    value && parseFloat(value) > number ?
        message.toString().replace('{number}', number) : undefined;

export const minLength = (message, min) => value => {
    if (!value) return undefined;
    return value.toString().length < min
        ? message.toString().replace('{min}', min)
        : undefined;
};